import React from "react";
import AddButton, { DeleteButton } from "../../buttons/button";

const Stat = ({ label, value }) => (
  <div className="flex flex-col items-center gap-0.5">
    <span className="text-[10px] font-bold tracking-wide uppercase text-[var(--description-color)] whitespace-nowrap">
      {label}
    </span>
    <span className="text-sm font-bold text-[var(--heading-color)] whitespace-nowrap">
      {value}
    </span>
  </div>
);

const BulkReturnFooter = ({
  itemsCount = 0,
  documentsCount = 0,
  amount = 0,
  discountPercent = 0,
  onDiscountPercentChange = () => {},
  onCancel = () => {},
  onCreate = () => {},
  createText = "Create Purchase Returns",
  createType = "button",
  showDiscount = true,
  disabled = false,
  containerClass = "shrink-0 border-t border-[var(--general-button-border)] bg-[var(--general-button-bg)] px-4 py-3 flex items-center justify-between gap-4 flex-wrap",
}) => {
  const createDisabled = itemsCount === 0 || disabled;

  return (
    <div className={containerClass}>
      <DeleteButton onclkFn={onCancel} text="Cancel" prefixIcon={false} />

      <div className="flex items-center gap-6 flex-wrap">
        <Stat label="Items" value={itemsCount} />
        <Stat label="Documents" value={documentsCount} />
        {showDiscount && (
          <div className="flex flex-col items-center gap-0.5">
            <span className="text-[10px] font-bold tracking-wide uppercase text-[var(--description-color)] whitespace-nowrap">
              Discount %
            </span>
            <input
              type="number"
              min={0}
              max={100}
              value={discountPercent}
              onChange={(e) =>
                onDiscountPercentChange(Math.min(100, Math.max(0, Number(e.target.value) || 0)))
              }
              className="w-16 text-center text-sm font-bold rounded-md border border-[var(--general-button-border)] px-1 py-0.5 focus:outline-none"
            />
          </div>
        )}
        <Stat
          label="Amount"
          value={`₹${Number(amount).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`}
        />

        <AddButton
          type={createType}
          text={createText}
          prefixIcon={false}
          isDisabled={createDisabled}
          onclkFn={onCreate}
          className={`px-6 py-2 rounded-md flex justify-center items-center fw_600 text-sm whitespace-nowrap ${
            createDisabled
              ? "bg-[var(--toggle-disabled-background)] text-[var(--general-button-disabled-fg)]"
              : "bg-[var(--primary)] text-white hover:opacity-90"
          }`}
        />
      </div>
    </div>
  );
};

export default BulkReturnFooter;
